/**
 * Capitalize a freshly-typed letter when it starts a new sentence:
 *   - first character in the input (only whitespace before)
 *   - first character after `.`, `!`, or `?` followed by whitespace
 *
 * Only acts on a single newly-typed lowercase letter; pastes, deletions,
 * and mid-sentence edits pass through unchanged.
 */
export const sentenceCaseTyping = (prev, next, cursorPos) => {
  if (typeof next !== "string") return next;
  if (next.length !== (prev?.length ?? 0) + 1) return next;

  const insertedAt = cursorPos - 1;
  if (insertedAt < 0 || insertedAt >= next.length) return next;

  const insertedChar = next[insertedAt];
  if (!/[a-z]/.test(insertedChar)) return next;

  const before = next.substring(0, insertedAt);
  const startsSentence = /^\s*$/.test(before) || /[.!?]\s+$/.test(before);
  if (!startsSentence) return next;

  return (
    next.substring(0, insertedAt) +
    insertedChar.toUpperCase() +
    next.substring(insertedAt + 1)
  );
};
